import React from 'react';

const today = new Date().toLocaleDateString('en-US', {
  weekday: 'long',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

const reminders = [
  '📌 Your KYC is still pending.',
  '📞 You have a mentor call scheduled tomorrow.',
  '💳 Your subscription expires in 3 days.',
];

export default function CalendarReminderBox() {
  return (
    <div className="bg-black p-4 shadow rounded-lg mb-6">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-sm font-semibold text-gray-700">🗓️ Today</h3>
        <span className="text-xs text-gray-500">{today}</span>
      </div>

      <ul className="text-sm space-y-1 text-gray-700">
        {reminders.map((reminder, index) => (
          <li key={index} className="flex items-start">
            <span>{reminder}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
